import { SKUDTO } from './SKUDTO'
import { MenuLinkTypeDTO } from './MenuLinkTypeDTO'

export class ConsumableDTO {
    constructor(
        public id: string,
        public displayName: string,
        public description: string | null,
        public skus: SKUDTO[],
        public modifierGroupIds: string[],
        public imageId: string | null = null
    ) { }
}

export class MenuDTO {
    constructor(
        public id: string,
        public displayName: string,
        public description: string | null,
        public linkType: MenuLinkTypeDTO,
        public menuCourses: MenuCourseDTO[],
        public minimumCoursesRequired: number | null = null,
        public maximumCoursesRequired: number | null = null,
        public isPaid: boolean = false
    ) { }
}

export class MenuCourseDTO {
    constructor(
        public id: string,
        public menuId: string,
        public displayName: string,
        public orderIndex: number,
        public minimumItemsRequired: number | null,
        public maximumItemsRequired: number | null,
        public menuItems: MenuItemDTO[],
        public excludesFromCourseCount: boolean = false,
        public description: string | null = null
    ) { }
}

export class MenuItemDTO {
    constructor(
        public id: string,
        public menuId: string,
        public menuCourseId: string,
        public consumableId: string,
        public skuId: string,
        public refundable: boolean = true,
        public paidOnline: boolean = true
    ) { }
}
